import { Box, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import GroupTable from "../../components/groupLoanComponent/groupLoanTable";
import CreateGroup from "../../components/groupLoanComponent/createGroupLoan";
import UpdateGroup from "../../components/groupLoanComponent/updateGroup";
import ViewGroupDetails from "../../components/groupLoanComponent/viewGroupDetails";
import GroupCollection from "./GroupCollections";
import GroupPigmyCollection from "./GroupPigmyCollections";

function GroupLoan() {
  const navigate = useNavigate();
  return (
    <>
      {" "}
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Group</Typography>
            </Box>

            <Box mt={1}>
              {/* Nested Routes will be rendered here  */}
              <Routes>
                <Route path="/" element={<GroupTable />} />
                <Route path="/create-group" element={<CreateGroup />} />
                <Route path="/update-group/:id" element={<UpdateGroup />} />
                <Route
                  path="view-group-details/:id"
                  element={<ViewGroupDetails />}
                />
                <Route path="/group-collection" element={<GroupCollection />} />
                <Route
                  path="/group-pigmy-collection"
                  element={<GroupPigmyCollection />}
                />
              </Routes>
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
        <Outlet />
      </div>
    </>
  );
}

export default GroupLoan;
